import {Link} from 'react-router-dom'
import { useLocation } from 'react-router'

const DEFAULT_MEMBER_AVATAR = '/image/default-avatar.svg'

const MemberInfo = ({info, idx}) => {
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    if(query.get('page')) { 
        idx += (query.get('page') - 1)* 10
    }
    return (
        <tr>
            <td>{idx}</td>
            <td><Link to={`/info/${info._id}`}><span>{`${info.firstName} ${info.fullName ? info.fullName : ''}`}</span> </Link></td>
            <td>
               <img
                src={info.image ? `/uploads/${info.image}` : DEFAULT_MEMBER_AVATAR}
                onError={({currentTarget}) => {
                    currentTarget.onerror = null
                    currentTarget.src = DEFAULT_MEMBER_AVATAR
                }}
                alt="صورة شخصية"
                style={{width:'4rem', height:'4rem', borderRadius:'50%', objectFit:'cover'}}/>
            </td>
            <td><span>{info.age}</span></td>
            <td><span>{info.maritalStatus}</span></td>
            <td><span>{info.job}</span></td>
            <td><span>{info.address}</span></td>
            <td><a href={`tel:${info.phone}`}>{info.phone}</a></td>
        </tr>
    )
}

export default MemberInfo
